import styled from "styled-components"

export const UserWrapper = styled.div`
position: relative;
.avatar{
    width: 45px;
    height: 45px;
    cursor: pointer;
    border-radius: 50%;
    img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: contain;
        background-color: whitesmoke;
    
    }
    &:hover .avatar_suggestion{
        display: block;
    }
   
}
.avatar_suggestion{
    position: absolute;
    width: 120px;
    background-color: #ffffff;
    top: 50px;
    list-style: none;
    padding: 0;
    border-radius: 5px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 1px 1px 4px rgb(0 0 0 / 15%);
    z-index: 18;
    display: none;
    animation: fadeOpacity linear 0.5s;
   .avatar_suggestion_item{
        height: 40px;
        &:first-child{
            a,span{
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
            }
            }
        &:last-child{
            a,span{
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
            }
            }
        a,span{
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 0 8px;
            i{
                margin-right: 8px;
            }
            &:hover{
                background-color: #e2c1c1;
                color: #741b75;
            }
        }
    }
    &::after{
        content: "";
        position: absolute;
        width: 100%;
        height: 10px;
        top: -10px;
        display: block;
    }
    @keyframes fadeOpacity {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
}
`